import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { api, V1 } from "@/lib/api";
import { LayoutDashboard, School, FileText, Calendar, Mail, MessageSquare, Package, Megaphone, BarChart3, Ticket, Image as ImageIcon, FileText as FileText2, Send, Target, History, UserPlus, Building2, CalendarClock, Receipt, Award } from "lucide-react";

const ALL_LINKS = [
  { to: "/okul-paneli", label: "Genel Bakış", icon: LayoutDashboard, end: true, perm: null },
  { to: "/okul-paneli/profil", label: "Okul Profili", icon: School, perm: "profile" },
  { to: "/okul-paneli/kampusler", label: "Kampüsler", icon: Building2, perm: "profile" },
  { to: "/okul-paneli/sinavlar", label: "Bursluluk Sınavları", icon: Calendar, perm: "exams" },
  { to: "/okul-paneli/basvurular", label: "Başvurular", icon: FileText, perm: "applications" },
  { to: "/okul-paneli/davetler", label: "Öğrenci Davetleri", icon: Mail, perm: "invitations" },
  { to: "/okul-paneli/gorusmeler", label: "Görüşmeler", icon: CalendarClock, perm: "meetings" },
  { to: "/okul-paneli/yorumlar", label: "Veli Yorumları", icon: MessageSquare, perm: null },
  { to: "/okul-paneli/analitik", label: "Başvuru Analitiği", icon: BarChart3, perm: null },
  { to: "/okul-paneli/deneme-sinavlarim", label: "Kendi Denemelerim", icon: Ticket, perm: "exams" },
  { to: "/okul-paneli/galeri", label: "Galeri", icon: ImageIcon, perm: "gallery" },
  { to: "/okul-paneli/brosur", label: "Broşür", icon: FileText2, perm: "brochure" },
  { to: "/okul-paneli/mesajlar", label: "Mesajlaşma", icon: Send, perm: "messaging" },
  { to: "/okul-paneli/hedefleme", label: "Öğrenci Hedefleme", icon: Target, perm: "targeting" },
  { to: "/okul-paneli/yerlestirme-verileri", label: "Yerleştirme Verileri", icon: Award, perm: "profile" },
  { to: "/okul-paneli/duyurular", label: "Duyurular", icon: Megaphone, perm: "announcements" },
  { to: "/okul-paneli/modullerim", label: "Modüllerim", icon: Package, perm: "modules" },
  { to: "/okul-paneli/odemelerim", label: "Ödemelerim", icon: Receipt, perm: "payments" },
  { to: "/okul-paneli/degisiklikler", label: "Değişiklik Kaydı", icon: History, perm: null },
  { to: "/okul-paneli/ekip", label: "Ekip Yönetimi", icon: UserPlus, perm: "team" },
];

export default function SchoolLayout() {
  // null = henüz yüklenmedi -> tüm linkleri göster (flash önlemek için); yüklenince filtrelenir.
  const [perms, setPerms] = useState(null);

  useEffect(() => {
    api.get(`${V1}/school/me/permissions`).then((r) => setPerms(r.data?.perms || [])).catch(() => setPerms(["*"]));
  }, []);

  const links = perms === null
    ? ALL_LINKS
    : ALL_LINKS.filter((l) => !l.perm || perms.includes("*") || perms.includes(l.perm));

  return <DashboardLayout links={links} title="Okul Paneli" testIdPrefix="school-sidebar" />;
}
